import { Controller } from "@hotwired/stimulus"
import { Chart } from 'chart.js/auto'

// Connects to data-controller="deal-match-chart"
export default class extends Controller {
  static values = {
    totalScore: Number,
    areaScore: Number,
    industryScore: Number,
    transactionValueScore: Number,
    narrativeScore: Number
  }

  connect() {
    const data = {
      labels: [
        '総合',
        '地域',
        '業界',
        '予算',
        '経緯',
      ],
      datasets: [{
        label: 'マッチ度スコア',
        data: [this.totalScoreValue, this.areaScoreValue, this.industryScoreValue, this.transactionValueScoreValue, this.narrativeScoreValue],
        fill: true,
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderColor: 'rgb(255, 99, 132)',
        pointBackgroundColor: 'rgb(255, 99, 132)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(255, 99, 132)'
      }]
    }
    this.call(data)
  }

  call(data) {
    const canvas = this.element.querySelector('#deal_match_score_chart')
    if (!canvas) return
    new Chart(canvas, {
      type: 'radar',
      data: data,
      options: {
        scales: {
          r: {
            min: 0,
            max: 100,
            ticks: {
              stepSize: 10
            }
          }
        },
        plugins: {
          legend: {
            display: false
          }
        }
      }
    })
  }
}
